<template>
  <v-card outlined>
    <v-card-text class="py-0">
      <v-row class="pb-2" dense>
        <v-col cols="12" md="12">
          <v-autocomplete
            id="location-anchor"
            :items="allStates"
            :value="selectedState"
            :loading="allStates.length == 0"
            @change="setState"
            label="Seleccione un estado"
            no-data-text="No hay datos para mostrar..."
            hint="Ctrl + L"
            persistent-hint
          />
        </v-col>
        <v-col cols="12" md="12">
          <v-autocomplete
            :items="allDestinies"
            :value="selectedDestiny"
            :disabled="selectedState == null"
            @change="setDestiny"
            label="Seleccione un municipio"
            no-data-text="No hay datos para mostrar..."
            persistent-hint
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  computed: {
    allStates() {
      return this.$store.state.destinies.allStates ?? [];
    },
    selectedState() {
      return this.$store.state.destinies.selectedState;
    },
    allDestinies() {
      return this.$store.state.destinies.filteredDestinies ?? [];
    },
    selectedDestiny() {
      return this.$store.state.destinies.selectedDestiny;
    },
  },
  methods: {
    setDestiny(value) {
      this.$store.commit("setSelectedDestiny", value);
      this.$store.dispatch("updateAllByDestiny");
    },
    setState(value) {
      this.$store.dispatch("changeSelectedState", value);
    },
    getDestinies() {
      this.$store.dispatch("getDestinies");
    },
  },
  created() {
    this.getDestinies();
  },
};
</script>